import {
  UPDATE_SETTINGS,
  UPDATE_SETTINGS_ERROR,
  GET_SETTING,
  SET_REF,
  SET_LANG,
} from "../types";
// import axios from "axios";
import customAxios from "../../utils/customAxios";
import { setAlert } from "../alert";

export const setLanguage = (lang) => async (dispatch) => {
  try {
    // const res = await customAxios.get("/api/admin/sitesetting/getsettings");
    dispatch({
      type: SET_LANG,
      payload: lang,
    });
  } catch (err) {
    dispatch({
      type: UPDATE_SETTINGS_ERROR,
      payload: { msg: err },
    });
  }
};

// Admin-only: reads the full settings document (SMTP credentials included),
// so it requires an admin token.
export const getSettingForMail = async () => {
  try {
    const res = await customAxios.get("/api/admin/sitesetting/getsettings");
    return res.data;
  } catch (err) {
    return [];
  }
};

export const setRef = (val) => async (dispatch) => {
  try {
    // const res = await customAxios.get("/api/admin/sitesetting/getsettings");
    dispatch({
      type: SET_REF,
      payload: val,
    });
  } catch (err) {
    dispatch({
      type: UPDATE_SETTINGS_ERROR,
      payload: { msg: err },
    });
  }
};

// Customer-site settings. Hits the public projection -- the full document is
// admin-only because it carries the SMTP credentials, and this action runs for
// every anonymous visitor via FrontLayout.
export const getSetting = () => async (dispatch) => {
  try {
    const res = await customAxios.get("/api/admin/sitesetting/public");
    localStorage.setItem("jsonstring", JSON.stringify(res.data));
    dispatch({
      type: GET_SETTING,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: UPDATE_SETTINGS_ERROR,
      payload: { msg: err },
    });
  }
};

// Full settings document for the admin settings screen (needs _id, smtpemail
// and smtppass, none of which the public endpoint returns). Deliberately not
// cached in localStorage.
export const getAdminSetting = () => async (dispatch) => {
  try {
    const res = await customAxios.get("/api/admin/sitesetting/getsettings");
    dispatch({
      type: GET_SETTING,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: UPDATE_SETTINGS_ERROR,
      payload: { msg: err },
    });
  }
};

export const getSettingEditBooking = async () => {
  try {
    const res = await customAxios.get("/api/admin/sitesetting/public");

    return res.data.editBooking;
  } catch (err) {
    console.log(err)
    return false;
  }
};

// add sitesetting
//
// Resolves to { ok, message } so the caller can report the outcome itself. The
// settings screen confirms behind a dialog and needs to know whether the write
// landed before it closes it -- an alert dispatched from in here would only be
// raised behind that dialog.
export const updateSettings = (formData) => async (dispatch) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const res = await customAxios.post(
      "/api/admin/sitesetting",
      formData,
      config
    );
    dispatch({
      type: UPDATE_SETTINGS,
      payload: res.data,
    });
    return { ok: true };
  } catch (err) {
    // A rejected save used to fail silently: the error landed in the store and
    // nothing on the settings screen reads it, so the admin saw no alert and
    // assumed the values had been written. Surface the server's own validation
    // messages instead.
    const errors = err?.response?.data?.errors;
    const message = Array.isArray(errors)
      ? errors.map((e) => e.msg).join(", ")
      : "Settings could not be saved. Please try again.";

    dispatch(setAlert(message, "danger"));
    dispatch({
      type: UPDATE_SETTINGS_ERROR,
      payload: { msg: err },
    });
    return { ok: false, message };
  }
};

export const getMeetAssistPrice = async () => {
  try {
    const res = await customAxios.get("/api/admin/sitesetting/get-meet-assist-price");
    return res.data;
  } catch (err) {
    return [];
  }
};
